<template>
  <Field
    as="div"
    :name="name || ''"
    :rules="rules"
    v-slot="{ field, errorMessage, value }"
    :model-value="modelValue"
    :value="modelValue"
  >
    <div class="relative w-full">
      <InputLabel
        :class="errorMessage ? 'text-error' : 'text-text'"
        :for="id"
        :placeholder="placeholder"
        :value="value"
      />
      <select
        v-bind="field"
        :name="name"
        :id="id"
        :disabled="disabled"
        :readonly="readonly"
        :required="required"
        :tabindex="tabindex"
        :class="[
          'px-4 w-full border rounded-sm bg-surface-light h-14 text-headings focus:outline-none focus:ring-1 focus:ring-input-border transition-colors appearance-none',
          value && !hideTitle ? 'pt-6 pb-2' : 'py-4',
          errorMessage ? 'border-error' : 'border-input-border',
          truncate ? 'overflow-hidden text-ellipsis whitespace-nowrap pr-6' : '',
        ]"
        @input="onInput"
      >
        <option v-if="forceChoice" value ="">
          {{ forceChoice }}
        </option>
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          :selected="option.value == modelValue"
        >
          {{ option.label }}
        </option>
      </select>
      <DropdownIcon
        class="absolute w-3 h-3 right-4 top-1/2 transform -translate-y-1/2 text-text pointer-events-none"
      />
    </div>
    <div v-if="errorMessage" class="text-sm block pt-2 text-error">
      {{ errorMessage }}
    </div>
  </Field>
</template>

<script setup lang="ts">
  import { Field } from 'vee-validate';

  import DropdownIcon from '@/components/icons/DropdownIcon.vue';

  import InputLabel from './InputLabel.vue';
  import { type InputProps } from './InputMixin';

  interface Option {
    label: string;
    value: string;
  }

  interface Props extends InputProps<string> {
    options: Option[];
    placeholder?: string;
    forceChoice?: string;
    hideTitle?: boolean;
    truncate?: boolean;
    tabindex?: number;
  }

  defineProps<Props>();

  const emit = defineEmits<{ 'update:modelValue': [value: string] }>();

  function updateValue(newValue: string) {
    emit('update:modelValue', newValue);
  }

  function onInput(event: Event) {
    const target = event.target as HTMLInputElement;

    updateValue(target.value);
  }
</script>
